import {
  Avatar,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import { t } from "i18next";
import { allIcons, allImages } from "../../../assets";
import GlobalButton from "../../../components/CustomButton";

const ClientDetails = ({ userDetails, onChatClick }) => {
  const selectedUser = {
    username: "John Doe",
    image: allImages.dumyMen1,
    contact: "+923444200515",
    address: " Wah Cantt Taxila, Islamabad",
    email: "johndoe@gmail.com",
  };

  const clientInfo = [
    {
      icon: allIcons.phoneOutgoingIcon,
      title: userDetails?.contact,
    },
    {
      icon: allIcons.googleLogoIcon,
      title: userDetails?.email,
    },
    // {
    //   icon: allIcons.smileyInactive,
    //   title: "View Profile",
    // },
  ];

  return (
    <Stack p={2} gap={1.5} alignItems={"center"} textAlign={"center"}>
      <Typography
        variant="h1"
        fontSize={"1.25rem"}
        fontWeight={500}
        textTransform={"capitalize"}
      >
        {t("clientDetails")}
      </Typography>
      <Avatar src={userDetails?.profileImg} sx={{ height: 100, width: 100 }} />
      <Box>
        <Typography variant="h1" fontSize={"1.125rem"} fontWeight={500}>
          {`${userDetails?.firstname} ${userDetails?.lastname}`}
        </Typography>
        <Typography variant="body2" fontSize={"0.875rem"}>
          {userDetails?.location}
        </Typography>
        {/* <List sx={{ mt: 1 }}>
          {clientInfo?.map((valll, index) => {
            return (
              <ListItem sx={{ py: "2px", cursor: "pointer" }}>
                <ListItemIcon sx={{ minWidth: 30 }}>
                  <img src={valll.icon} alt={valll.title} width={20} />
                </ListItemIcon>
                <ListItemText
                  primary={valll.title}
                  sx={{
                    "& .MuiListItemText-primary ": {
                      fontSize: "0.875rem",
                    },
                  }}
                />
              </ListItem>
            );
          })}
        </List> */}

        <GlobalButton
          btnText={"chatWithMe"}
          handleClickBtn={onChatClick}
          startIcon={
            <img src={allIcons.chatWhiteIcon} alt={"chat-icon"} width={20} />
          }
          styleProps={{
            marginTop: "10px",
            width: 160,
            height: 40,
            fontWeight: 400,
            textTransform: "lowercase",
          }}
        />
      </Box>
    </Stack>
  );
};

export default ClientDetails;
